import { graphql } from 'gql'

export const UPDATE_WORKSPACE_FOR_GLOBAL_SETUP_GENERAL = graphql(`
  mutation updateWorkspaceForGlobalSetupGeneral(
    $input: UpdateWorkspaceInput!
    $canReadPriceGenius: Boolean!
  ) {
    updateWorkspace(input: $input) {
      workspace {
        ...WorkspaceFragmentForGeneralSetupGeneral
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`)
